const defaultState = {
  notifications: [],
}

export default defaultState
